"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RoomInfo = void 0;
var core_1 = require("@material-ui/core");
var react_1 = __importDefault(require("react"));
var RoomInfo = function (_a) {
    var icon = _a.icon, roomNo = _a.roomNo, date = _a.date, time = _a.time, value = _a.value;
    return (react_1.default.createElement("div", { className: "my-room-info" },
        react_1.default.createElement("div", { className: "room-content" },
            react_1.default.createElement(core_1.ListItemAvatar, null,
                react_1.default.createElement(core_1.Avatar, { className: "svg-icon", src: icon })),
            react_1.default.createElement("div", { className: "container" },
                react_1.default.createElement("div", { className: "fs-10 fw-medium shadow" }, "Room"),
                react_1.default.createElement("div", { className: "fs-18 fw-bold room-no shadow" }, roomNo))),
        react_1.default.createElement("div", { className: "flex-width desc m-b-4" },
            react_1.default.createElement("span", { className: " fw-500 duration-icon color-text" }, date),
            react_1.default.createElement("div", { className: " fw-500 time-label" }, time),
            ' '),
        react_1.default.createElement("div", { className: "progress " },
            react_1.default.createElement("div", { className: "progress-bar", style: { width: "".concat(value, "%") } }))));
};
exports.RoomInfo = RoomInfo;
//# sourceMappingURL=RoomInfo.js.map